import React from "react";

class Tos extends React.Component {
  render() {
    return (
      <section className="authentication-form download">
        <nav className="navbar navbar-expand-lg navbar-light theme-nav fixed-top">
          <div id="navbar-main" className="container">
            <a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}>
              <img src="assets/images/logo.png" alt="logo" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className="collapse navbar-collapse default-nav"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto" id="mymenu">
                <li className="nav-item">
                  <a className="nav-link" href={`${process.env.PUBLIC_URL}/`}>
                    Αρχικη
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className="innerpage-decor">
          <div className="innerpage-circle1">
            <img src="assets/images/Testimonial2.png" alt="" />
          </div>
          <div className="innerpage-circle2">
            <img src="assets/images/Testimonial1.png" alt="" />
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="contact-us">
                <div className="w-100 justify-content-center m-auto">
                  <h2
                    className="title "
                    style={{ textAlign: "center", textTransform: "none" }}
                  >
                    Πολιτική Cookies
                  </h2>
                  <div className="d-flex w-100 justify-content-between">
                    <p className="mb-1 text-justify">
                      Η QRSTAND σέβεται την ιδιωτικότητά σας και προσπαθεί να
                      συγκεντρώνει μόνο τα στοιχεία σας, τα οποία είναι
                      απαραίτητα για την εύρυθμη λειτουργία της, διασφαλίζοντας
                      ταυτόχρονα ένα πολύ υψηλό επίπεδο εμπειρίας χρήσης της.
                      Παρότι τα cookies από μόνα τους δεν μπορούν να αναζητήσουν
                      ή να επεξεργαστούν τις πληροφορίες σας ή να
                      πραγματοποιήσουν αναζήτηση στον υπολογιστή σας,
                      αποθηκεύουν προσωπικές σας πληροφορίες σχετικά με το
                      ιστορικό επισκεψιμότητας ιστοσελίδων ή τις ηλεκτρονικές
                      σας αγορές. Γι’ αυτό τον σκοπό σας ενημερώνουμε για την
                      χρήση των cookies από την ιστοσελίδα μας και σας
                      βεβαιώνουμε ότι προσπαθούμε να είναι όσο το δυνατόν
                      ασφαλής με την ελάχιστη δυνατή παρέμβαση στην ιδιωτικότητά
                      σας. <br />
                      <br />
                      <strong>Πώς και γιατί χρησιμοποιούμε cookies</strong>
                      <br />
                      Στην ιστοσελίδα μας χρησιμοποιούμε cookies προκειμένου να
                      βελτιώσουμε την ασφάλεια και την εμπειρία χρήσης της.
                      Ορισμένα από τα cookies που χρησιμοποιούμε σας επιτρέπουν
                      να επιλέγετε τον τρόπο με τον οποίο έχετε πρόσβαση στην
                      ιστοσελίδα μας, να συνδέεστε στις ηλεκτρονικές μας
                      υπηρεσίες, να συμπληρώνετε τις ηλεκτρονικές φόρμες που
                      χρησιμοποιεί η ιστοσελίδα μας και να επικοινωνείτε μαζί
                      μας. Το κείμενο που διαβάζετε «Πολιτική cookies» εξηγεί με
                      απλά λόγια τι είναι τα cookies, ποια cookies
                      χρησιμοποιούμε, πώς τα χρησιμοποιούμε και πώς μπορείτε να
                      τα διαχειριστείτε. Αντιλαμβάνεστε ότι δεν είναι τεχνικά
                      εφικτό να σας παράσχουμε εμείς εκ προοιμίου την επιλογή να
                      ενεργοποιηθούν/απενεργοποιηθούν επιλεκτικά τα cookies της
                      ιστοσελίδας. Με την περιήγησή σας στην ιστοσελίδα
                      συγκατατίθεστε στην χρήση των cookies που αυτή
                      χρησιμοποιεί. Μπορείτε ωστόσο να τροποποιήσετε τις
                      ρυθμίσεις του browser που χρησιμοποιείτε για να
                      περιηγείστε στο διαδίκτυο έτσι ώστε να περιορίσετε
                      σημαντικά την χρήση cookies (Δείτε κατωτέρω «πώς μπορείτε
                      να διαχειρίζεστε τα cookies»).
                      <strong>Τι είναι τα cookies;</strong>
                      <br />
                      Τα cookies είναι μικρά αρχεία κειμένου που αποστέλλονται
                      και αποθηκεύονται στον υπολογιστή σας, στο smartphone ή σε
                      άλλη συσκευή που χρησιμοποιείται για πρόσβαση στο
                      Internet, όποτε επισκέπτεστε έναν δικτυακό τόπο. Τα
                      cookies είναι κατ’ αρχήν απαραίτητα διότι επιτρέπουν σε
                      έναν δικτυακό τόπο να αναγνωρίζει τη συσκευή ενός χρήστη
                      και να προσαρμόζει το περιεχόμενό του σε αυτήν. Για
                      παράδειγμα ο ιστότοπος θυμάται τις ενέργειές σας και τις
                      προτιμήσεις σας (όπως κωδικός σύνδεσης, γλώσσα, μέγεθος
                      γραμματοσειράς και άλλες προτιμήσεις απεικόνισης) για ένα
                      χρονικό διάστημα, κι έτσι δεν χρειάζεται να εισάγετε τις
                      προτιμήσεις αυτές κάθε φορά που επισκέπτεστε τον ιστότοπο
                      ή κάποια άλλη σελίδα σε αυτόν.Εάν θέλετε να μάθετε
                      περισσότερα για τα cookies με την μπορείτε να επισκεφτείτε
                      κάποιον από τους εξειδικευμένους ιστοτόπους όπως για
                      παράδειγμα{" "}
                      <a
                        style={{ color: "#555179" }}
                        href="https://cookies.insites.com/"
                      >
                        cookies.insites.com
                      </a>
                      . Τα cookies δεν είναι ιοί. Δεν είναι κομμάτια κώδικα.
                      Συνεπώς, δεν μπορούν να πολλαπλασιαστούν και να εξαπλωθούν
                      σε άλλα δίκτυα. Δεδομένου ότι δεν μπορούν να εκτελέσουν
                      αυτές τις λειτουργίες, δεν εμπίπτουν στον τυπικό ορισμό
                      του ιού.
                      <br />
                      <br />
                      <strong>Ποια cookies χρησιμοποιούμε</strong>
                      <br />
                      Όλα τα cookies που χρησιμοποιούμε είναι απαραίτητα για την
                      λειτουργία της ιστοσελίδας μας και των υπηρεσιών που αυτή
                      προσφέρει ή για την βελτίωση της εμπειρίας χρήσης της,
                      σύμφωνα με τις κατευθυντήριες της Ευρωπαϊκής Επιτροπής
                      σύμφωνα με την εφαρμοστέα νομοθεσία (περισσότερα εδώ:
                      <a
                        style={{ color: "#555179" }}
                        href="http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm"
                      >
                        ec.europa.eu/ipg/basics/legal/cookies/index_en.htm
                      </a>
                      ) Ορισμένα cookies είναι απαραίτητα για την παροχή των
                      ηλεκτρονικών υπηρεσιών της ιστοσελίδας μας και συνεπώς η
                      χρήση τους είναι αδύνατη χωρίς αυτά. Τα απαραίτητα Cookies
                      που χρησιμοποιούμε είναι τα εξής:
                      <br />
                      SESSION ID: Το cookie αυτό χρησιμοποιείται για να αυξήσει
                      την ασφάλεια χρήσης της ιστοσελίδας, καθώς αναγνωρίζει
                      τους χρήστες ανά πρόγραμμα περιήγησης (browser). Χωρίς
                      αυτό, ο διακομιστής (server) δεν μπορεί να διακρίνει τους
                      διαφορετικούς χρήστες στην ίδια συνεδρία που χρησιμοποιούν
                      διαφορετικά προγράμματα περιήγησης (browsers). To cookie
                      αυτό τηρείται σε ισχύ για 30 ημέρες από την δημιουργία
                      του. <br />
                      JWT TOKEN: Αυτό το cookie είναι σημαντικό για την ασφάλειά
                      σας. Χρησιμοποιείται για να ενημερώσει τον διακομιστή
                      (server) ότι η διαδικασία πιστοποίησης κατά τη σύνδεσή σας
                      είναι επιβεβαιωμένη. Χωρίς αυτό το cookie θα χρειαζόταν
                      κάθε φορά που χρησιμοποιείτε τις διάφορες υπηρεσίες να
                      γίνεται εκ νέου επιβεβαιώση της διαδικασίας πιστοποίησης.
                      To cookie αυτό τηρείται σε ισχύ για 30 ημέρες από την
                      δημιουργία του. <br />
                      <br />
                      <strong>Πώς μπορείτε να διαχειρίζεστε τα cookies;</strong>
                      <br />
                      Τα προγράμματα περιήγησης των περισσότερων υπολογιστών,
                      smartphone και άλλων συσκευών με δυνατότητα πρόσβασης στο
                      Web είναι ρυθμισμένα από προεπιλογή να αποδέχονται τα
                      cookies. Παρ’ όλα αυτά όλα τα προγράμματα περιήγησης έχουν
                      ενσωματωμένες ρυθμίσεις απορρήτου οι οποίες παρέχουν
                      διαφορετικά επίπεδα αποδοχής των cookies ή του χρόνου κατά
                      τον οποίο αποθηκεύονται αφού ένας χρήστης έχει επισκεφθεί
                      έναν συγκεκριμένο ιστότοπο. Αν θέλετε να τροποποιήσετε τις
                      προτιμήσεις σας σχετικά με τα cookies για τον παρόντα
                      δικτυακό τόπο ή για άλλους δικτυακούς τόπους, μπορείτε να
                      το κάνετε μέσω των ρυθμίσεων του προγράμματος περιήγησης
                      που χρησιμοποιείτε. Για να δείτε πώς μπορεί να γίνει αυτό
                      κάντε αναζήτηση στις επιλογές «Βοήθεια» / “Help” του
                      προγράμματος περιήγησης που χρησιμοποιείτε. Κάθε πρόγραμμα
                      περιήγησης έχει διαφορετικό τρόπο με τον οποίο μπορείτε να
                      απενεργοποιήσετε/ αποκλείσετε τα cookies. Ωστόσο,
                      παρακαλούμε λάβετε υπόψη σας ότι ορισμένα από τα cookies
                      είναι απαραίτητα για την λειτουργία της ιστοσελίδας μας
                      και των υπηρεσιών που αυτή προσφέρει. Αν επιλέξετε να
                      απενεργοποιήσετε ορισμένα cookies, αυτό είναι πιθανό να
                      επηρεάσει τον τρόπο λειτουργίας του ιστότοπου μας. Σε αυτή
                      την περίπτωση δεν φέρουμε καμία ευθύνη για τυχόν αστοχίες
                      στις προσφερόμενες από τον ιστότοπό μας υπηρεσίες.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Tos;



// WEBPACK FOOTER //
// ./src/pages/cookiePolicy.js